import noWatermarkFeatures from '../TTS/NoWatermark';
import concurrentProjectsFeatures from './ConcurrentProjects';
import numberSpeakerFeatures from './NumberSpeaker';
import srtFileDurationFeatures from './SRTFileDuration';
import aiRewriteFeatures from './AIRewrite';
import aiTranslationFeatures from './AITranslation';
import slideDubbingFeatures from './SlideDubbing';
import transcriptAudioFeatures from './TranscriptAudio';

const projectFeatures = ({ packages }) => ({
  noWatermark: {
    key: 'no-watermark-project',
    label: 'noWatermarkTextToSpeech',
    values: noWatermarkFeatures({ packages }),
  },
  concurrentProjects: {
    key: 'concurrent-projects',
    label: 'concurrentProjects',
    values: concurrentProjectsFeatures({ packages }),
  },
  numberSpeaker: {
    key: 'number-speaker',
    label: 'numberSpeaker',
    values: numberSpeakerFeatures({ packages }),
  },
  srtFileDuration: {
    key: 'srt-project-duration',
    label: 'srtProjectDuration',
    values: srtFileDurationFeatures({ packages }),
  },
});

const projectNewFeatures = ({ packages }) => {
  const aiRewrite = aiRewriteFeatures({ packages });
  const aiTranslation = aiTranslationFeatures({ packages });
  const slideDubbing = slideDubbingFeatures({ packages });
  const transcriptAudio = transcriptAudioFeatures({ packages });

  return {
    ...projectFeatures({ packages }),
    aiRewrite: {
      ...aiRewrite.costPerCharacter,
      label: 'aiRewriteText',
    },
    aiTranslation: {
      ...aiTranslation.costPerCharacter,
      label: 'aiTranslateText',
    },
    slideDubbing: {
      ...slideDubbing.enabled,
      type: 'sub-group',
      label: 'slideDubbing',
      children: [
        { ...slideDubbing.aiPresentationScript, label: 'aiPresentationScript' },
      ],
    },
    transcriptAudio: {
      ...transcriptAudio.enabled,
      label: 'transcriptAudio',
    },
  };
};

export default projectFeatures;
export { projectNewFeatures };
